import { render } from "./packageManagement.vue?vue&type=template&id=a30275b4&scoped=true"
import script from "./packageManagement.vue?vue&type=script&lang=js"
export * from "./packageManagement.vue?vue&type=script&lang=js"

import "./packageManagement.vue?vue&type=style&index=0&id=a30275b4&lang=scss&scoped=true"
import "./packageManagement.vue?vue&type=style&index=1&id=a30275b4&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a30275b4"]])

export default __exports__